<div class="signatura-verification">
  <h5 class="fs-4 fw-bold card-title mb-4">Verificación de Firma Electrónica</h5>

  <div class="mb-3">
    <p class="fs-6">Vamos a enviarte un link a tu teléfono para que puedas firmar el contrato de forma segura.</p>
  </div>

  <div class="verification-content mt-4">
    <div *ngIf="verificationStatus === 'pending'" class="verification-pending text-center">
      <div class="spinner-border text-primary mb-3" role="status">
        <span class="visually-hidden">Cargando...</span>
      </div>
      <p>Preparando documento...</p>
    </div>

    <div *ngIf="verificationStatus === 'in_progress'" class="verification-active">
      <div class="alert alert-info mb-3">
        <i class="bi bi-envelope-fill"></i>
        <strong>Mensaje de texto enviado</strong><br />
        Revisa tus mensajes de texto y completa la firma del documento.
      </div>

      <div class="email-instructions">
        <h6 class="mb-3">Instrucciones:</h6>
        <ol class="text-start">
          <li>En tu celular, revisa tus mensajes de texto</li>
          <li>Haz click en el enlace de la firma</li>
          <li>Completa el proceso de firma electrónica</li>
        </ol>
      </div>

      <div class="polling-status text-center mt-4">
        <div class="spinner-border spinner-border-sm me-2" role="status"></div>
        <small>Esperando que completes la firma...</small>
      </div>
    </div>

    <div *ngIf="verificationStatus === 'completed'" class="verification-success text-center">
      <div class="alert alert-success">
        <i class="bi bi-check-circle-fill"></i>
        <strong>¡Firma completada!</strong><br />
        Tu documento ha sido firmado exitosamente
      </div>
      <div class="success-animation mb-3">
        <i class="bi bi-check-circle-fill text-success" style="font-size: 3rem"></i>
      </div>
      <p>Redirigiendo automáticamente...</p>
    </div>

    <div *ngIf="verificationStatus === 'failed'" class="verification-error text-center">
      <div class="alert alert-danger">
        <i class="bi bi-exclamation-triangle-fill"></i>
        <strong>Error en la firma</strong><br />
        Hubo un problema con el proceso de firma electrónica
      </div>
      <div class="error-actions mt-3">
        <app-button size="small" (clicked)="retryVerification()">
          Reintentar
        </app-button>
      </div>
    </div>
  </div>
</div>
